import api from "@/infrastructure/api/axios";
import { platformReviewsApiResponseSchema, providerReviewsApiResponseSchema, reviewReplySchema, } from "../models";
export const providerReviewRepository = {
    async getReviews(scope) {
        const endpoint = scope === "concierge" ? "/concierge/reviews" : "/provider/reviews";
        const response = await api.get(endpoint);
        return providerReviewsApiResponseSchema.parse(response.data);
    },
    async getProviderReviews() {
        const response = await api.get("/provider/reviews");
        return providerReviewsApiResponseSchema.parse(response.data);
    },
    async getPlatformReviews(filters = {}) {
        const params = Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== undefined && value !== ""));
        const response = await api.get("/admin/global/reviews", { params });
        return platformReviewsApiResponseSchema.parse(response.data);
    },
    async createProviderReply(reviewId, body) {
        const response = await api.post(`/provider/reviews/${reviewId}/reply`, {
            body,
        });
        return reviewReplySchema.parse(response.data);
    },
    async updateProviderReply(reviewId, body) {
        const response = await api.patch(`/provider/reviews/${reviewId}/reply`, {
            body,
        });
        return reviewReplySchema.parse(response.data);
    },
    async deleteProviderReply(reviewId) {
        await api.delete(`/provider/reviews/${reviewId}/reply`);
    },
    async moderateReview(reviewId, action, reason) {
        const response = await api.patch(`/admin/global/reviews/${reviewId}/moderation`, { action, reason });
        return response.data;
    },
    async moderateReply(replyId, action, reason) {
        const response = await api.patch(`/admin/global/reviews/replies/${replyId}/moderation`, { action, reason });
        return reviewReplySchema.parse(response.data);
    },
};
export default providerReviewRepository;
